import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  getMyStore, putMyStoreConfig,
  addProduct, editProduct, deleteProduct
} from '../services/api';

const S = {
  wrap: { minHeight: '100vh', background: '#0f0f14', color: '#e2e8f0', fontFamily: "'Segoe UI', sans-serif" },
  nav: {
    background: 'rgba(255,255,255,0.03)', borderBottom: '1px solid rgba(255,255,255,0.08)',
    padding: '0 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '60px',
  },
  navBrand: { color: '#34d399', fontWeight: 700, fontSize: '18px' },
  navRight: { display: 'flex', gap: '12px', alignItems: 'center' },
  btnSm: {
    padding: '7px 14px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.12)',
    background: 'transparent', color: '#94a3b8', fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit',
  },
  main: { maxWidth: '1100px', margin: '0 auto', padding: '32px 24px' },
  tabs: { display: 'flex', gap: '4px', marginBottom: '28px', borderBottom: '1px solid rgba(255,255,255,0.08)', paddingBottom: '0' },
  tab: (active) => ({
    padding: '10px 20px', borderRadius: '8px 8px 0 0', fontSize: '14px', fontWeight: 500,
    cursor: 'pointer', border: 'none', fontFamily: 'inherit',
    background: active ? 'rgba(52,211,153,0.12)' : 'transparent',
    color: active ? '#34d399' : '#64748b',
    borderBottom: active ? '2px solid #34d399' : '2px solid transparent',
    marginBottom: '-1px',
  }),
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' },
  prodCard: {
    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '14px', overflow: 'hidden',
  },
  prodImg: { width: '100%', height: '160px', objectFit: 'cover', background: 'rgba(255,255,255,0.05)' },
  prodImgPlaceholder: {
    width: '100%', height: '160px', background: 'rgba(255,255,255,0.04)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '36px',
  },
  prodBody: { padding: '14px 16px' },
  prodName: { fontWeight: 600, color: '#f1f5f9', marginBottom: '4px', fontSize: '15px' },
  prodPrice: { color: '#34d399', fontWeight: 700, fontSize: '16px', marginBottom: '6px' },
  prodCat: { fontSize: '12px', color: '#64748b', marginBottom: '10px' },
  prodActions: { display: 'flex', gap: '8px' },
  btnAct: (v) => ({
    flex: 1, padding: '7px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)',
    fontSize: '12px', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'center',
    background: v === 'danger' ? 'rgba(239,68,68,0.1)' : 'rgba(255,255,255,0.06)',
    color: v === 'danger' ? '#fca5a5' : '#cbd5e1',
  }),
  addBtn: {
    width: '100%', padding: '40px', borderRadius: '14px',
    border: '2px dashed rgba(255,255,255,0.1)', background: 'transparent',
    color: '#475569', fontSize: '14px', cursor: 'pointer', fontFamily: 'inherit',
  },
  configGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' },
  label: { display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: '13px', marginBottom: '6px' },
  input: {
    width: '100%', padding: '11px 14px',
    background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: '10px', color: '#fff', fontSize: '14px',
    marginBottom: '16px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit',
  },
  btnPrimary: {
    padding: '11px 24px', borderRadius: '10px', border: 'none',
    background: 'linear-gradient(135deg, #059669, #0d9488)',
    color: '#fff', fontWeight: 600, fontSize: '14px', cursor: 'pointer', fontFamily: 'inherit',
  },
  modal: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: '20px',
  },
  modalCard: {
    background: '#1a1a2e', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '18px', padding: '32px', width: '100%', maxWidth: '480px',
    maxHeight: '90vh', overflowY: 'auto',
  },
  mTitle: { fontSize: '20px', fontWeight: 700, color: '#f1f5f9', marginBottom: '20px' },
  row: { display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '8px' },
  err: { color: '#fca5a5', fontSize: '13px', marginBottom: '12px', background: 'rgba(239,68,68,0.1)', padding: '10px', borderRadius: '8px' },
  ok: { color: '#86efac', fontSize: '13px', marginBottom: '12px', background: 'rgba(34,197,94,0.1)', padding: '10px', borderRadius: '8px' },
  textarea: {
    width: '100%', padding: '11px 14px',
    background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: '10px', color: '#fff', fontSize: '14px',
    marginBottom: '16px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit',
    resize: 'vertical', minHeight: '80px',
  },
  highlight: (on) => ({
    padding: '3px 8px', borderRadius: '6px', fontSize: '11px',
    background: on ? 'rgba(234,179,8,0.15)' : 'transparent',
    color: on ? '#fde047' : 'transparent',
    border: on ? '1px solid rgba(234,179,8,0.3)' : '1px solid transparent',
    marginLeft: '6px',
  }),
};

const emptyProd = { nombre: '', precio: '', categoria: '', descripcion: '', imagen: '', destacado: false };

export default function DashboardPage() {
  const { token, user, signOut } = useAuth();
  const [store, setStore]     = useState(null);
  const [tab, setTab]         = useState('productos');
  const [modal, setModal]     = useState(null);
  const [editing, setEditing] = useState(null);
  const [prodForm, setProdForm] = useState(emptyProd);
  const [configForm, setConfigForm] = useState({});
  const [err, setErr]         = useState('');
  const [ok, setOk]           = useState('');
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    try { setStore(await getMyStore(token)); } catch {}
  }, [token]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (store?.config) {
      setConfigForm({
        nombre: store.config.nombre || '',
        descripcion: store.config.descripcion || '',
        color: store.config.color || '#6C5CE7',
        moneda: store.config.moneda || 'ARS',
        whatsapp: store.config.whatsapp || '',
        mp_public_key: store.config.mp_public_key || '',
        mp_access_token: '',
      });
    }
  }, [store]);

  const openAdd = () => { setProdForm(emptyProd); setEditing(null); setErr(''); setModal('prod'); };
  const openEdit = (p) => { setProdForm({ ...p, precio: String(p.precio) }); setEditing(p.id); setErr(''); setModal('prod'); };

  const handleSaveProd = async () => {
    setErr(''); setLoading(true);
    try {
      const body = { ...prodForm, precio: parseFloat(prodForm.precio) || 0 };
      if (editing) await editProduct(editing, body, token);
      else await addProduct(body, token);
      await load(); setModal(null);
    } catch (e) { setErr(e.message); } finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este producto?')) return;
    try { await deleteProduct(id, token); await load(); } catch {}
  };

  const handleConfig = async () => {
    setErr(''); setOk(''); setLoading(true);
    try {
      await putMyStoreConfig(configForm, token);
      await load();
      setOk('Configuración guardada correctamente.');
    } catch (e) { setErr(e.message); } finally { setLoading(false); }
  };

  const monedaSymbol = store?.config?.moneda === 'USD' ? '$' : store?.config?.moneda === 'EUR' ? '€' : '$';

  return (
    <div style={S.wrap}>
      <nav style={S.nav}>
        <span style={S.navBrand}>🏪 {store?.config?.nombre || 'Mi Tienda'}</span>
        <div style={S.navRight}>
          {user?.clientId && (
            <a
              href={`/tienda/${user.clientId}`}
              target="_blank"
              rel="noreferrer"
              style={{ ...S.btnSm, color: '#34d399', textDecoration: 'none' }}
            >
              Ver tienda ↗
            </a>
          )}
          <button style={{ ...S.btnSm, color: '#fca5a5' }} onClick={signOut}>Salir</button>
        </div>
      </nav>

      <div style={S.main}>
        <div style={S.tabs}>
          <button style={S.tab(tab === 'productos')} onClick={() => setTab('productos')}>
            Productos ({store?.productos?.length || 0}/30)
          </button>
          <button style={S.tab(tab === 'config')} onClick={() => setTab('config')}>
            Configuración
          </button>
        </div>

        {/* TAB PRODUCTOS */}
        {tab === 'productos' && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: '#f1f5f9' }}>Productos</h2>
              {(store?.productos?.length || 0) < 30 && (
                <button style={S.btnPrimary} onClick={openAdd}>+ Agregar producto</button>
              )}
            </div>
            {(store?.productos?.length || 0) >= 30 && (
              <div style={{ ...S.err, marginBottom: '16px' }}>Alcanzaste el límite de 30 productos.</div>
            )}
            <div style={S.grid}>
              {store?.productos?.map(p => (
                <div key={p.id} style={S.prodCard}>
                  {p.imagen
                    ? <img src={p.imagen} alt={p.nombre} style={S.prodImg} onError={e => { e.target.style.display = 'none'; }} />
                    : <div style={S.prodImgPlaceholder}>📦</div>
                  }
                  <div style={S.prodBody}>
                    <div style={S.prodName}>
                      {p.nombre}
                      {p.destacado && <span style={S.highlight(true)}>★ Destacado</span>}
                    </div>
                    <div style={S.prodPrice}>{monedaSymbol}{Number(p.precio).toLocaleString('es-AR')}</div>
                    {p.categoria && <div style={S.prodCat}>{p.categoria}</div>}
                    <div style={S.prodActions}>
                      <button style={S.btnAct()} onClick={() => openEdit(p)}>Editar</button>
                      <button style={S.btnAct('danger')} onClick={() => handleDelete(p.id)}>Eliminar</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* TAB CONFIG */}
        {tab === 'config' && (
          <div style={{ maxWidth: '600px' }}>
            <h2 style={{ margin: '0 0 20px', fontSize: '18px', fontWeight: 600, color: '#f1f5f9' }}>Configuración de tu tienda</h2>
            {err && <div style={S.err}>{err}</div>}
            {ok && <div style={S.ok}>{ok}</div>}
            <div style={S.configGrid}>
              <div>
                <label style={S.label}>Nombre de la tienda</label>
                <input style={S.input} value={configForm.nombre || ''} onChange={e => setConfigForm({ ...configForm, nombre: e.target.value })} />
              </div>
              <div>
                <label style={S.label}>Moneda</label>
                <select style={{ ...S.input, marginBottom: '16px' }} value={configForm.moneda || 'ARS'} onChange={e => setConfigForm({ ...configForm, moneda: e.target.value })}>
                  <option value="ARS">ARS — Peso argentino</option>
                  <option value="USD">USD — Dólar</option>
                  <option value="EUR">EUR — Euro</option>
                  <option value="UYU">UYU — Peso uruguayo</option>
                </select>
              </div>
            </div>
            <label style={S.label}>Descripción</label>
            <textarea style={S.textarea} value={configForm.descripcion || ''} onChange={e => setConfigForm({ ...configForm, descripcion: e.target.value })} />
            <div style={S.configGrid}>
              <div>
                <label style={S.label}>Color primario</label>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '16px' }}>
                  <input type="color" value={configForm.color || '#6C5CE7'} onChange={e => setConfigForm({ ...configForm, color: e.target.value })}
                    style={{ width: '40px', height: '40px', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '8px' }} />
                  <input style={{ ...S.input, marginBottom: 0, flex: 1 }} value={configForm.color || ''} onChange={e => setConfigForm({ ...configForm, color: e.target.value })} />
                </div>
              </div>
              <div>
                <label style={S.label}>WhatsApp (solo números)</label>
                <input style={S.input} value={configForm.whatsapp || ''} onChange={e => setConfigForm({ ...configForm, whatsapp: e.target.value })} placeholder="5491112345678" />
              </div>
            </div>
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '20px', marginTop: '4px' }}>
              <div style={{ color: '#f1f5f9', fontWeight: 600, marginBottom: '4px' }}>MercadoPago</div>
              <div style={{ color: '#64748b', fontSize: '13px', marginBottom: '14px' }}>
                Configurá tus credenciales para recibir pagos.
                {store?.config?.mp_access_token_configured && (
                  <span style={{ color: '#86efac', marginLeft: '8px' }}>✓ Access Token configurado</span>
                )}
              </div>
              <label style={S.label}>Access Token (dejá vacío para no modificar)</label>
              <input style={S.input} type="password" value={configForm.mp_access_token || ''} onChange={e => setConfigForm({ ...configForm, mp_access_token: e.target.value })} placeholder="TEST-xxx... o APP_USR-xxx..." />
              <label style={S.label}>Public Key</label>
              <input style={S.input} value={configForm.mp_public_key || ''} onChange={e => setConfigForm({ ...configForm, mp_public_key: e.target.value })} placeholder="TEST-xxx... o APP_USR-xxx..." />
            </div>
            <button style={{ ...S.btnPrimary, opacity: loading ? 0.7 : 1 }} onClick={handleConfig} disabled={loading}>
              {loading ? 'Guardando...' : 'Guardar configuración'}
            </button>
          </div>
        )}
      </div>

      {/* MODAL PRODUCTO */}
      {modal === 'prod' && (
        <div style={S.modal} onClick={() => setModal(null)}>
          <div style={S.modalCard} onClick={e => e.stopPropagation()}>
            <div style={S.mTitle}>{editing ? 'Editar producto' : 'Agregar producto'}</div>
            {err && <div style={S.err}>{err}</div>}
            <label style={S.label}>Nombre *</label>
            <input style={S.input} value={prodForm.nombre} onChange={e => setProdForm({ ...prodForm, nombre: e.target.value })} />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div>
                <label style={S.label}>Precio *</label>
                <input style={S.input} type="number" min="0" step="0.01" value={prodForm.precio} onChange={e => setProdForm({ ...prodForm, precio: e.target.value })} />
              </div>
              <div>
                <label style={S.label}>Categoría</label>
                <input style={S.input} value={prodForm.categoria} onChange={e => setProdForm({ ...prodForm, categoria: e.target.value })} />
              </div>
            </div>
            <label style={S.label}>Descripción</label>
            <textarea style={S.textarea} value={prodForm.descripcion} onChange={e => setProdForm({ ...prodForm, descripcion: e.target.value })} />
            <label style={S.label}>URL de imagen</label>
            <input style={S.input} value={prodForm.imagen} onChange={e => setProdForm({ ...prodForm, imagen: e.target.value })} placeholder="https://..." />
            <label style={{ ...S.label, display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '16px' }}>
              <input type="checkbox" checked={prodForm.destacado} onChange={e => setProdForm({ ...prodForm, destacado: e.target.checked })} />
              Producto destacado
            </label>
            <div style={S.row}>
              <button style={S.btnSm} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...S.btnPrimary, opacity: loading ? 0.7 : 1 }} onClick={handleSaveProd} disabled={loading}>
                {loading ? 'Guardando...' : editing ? 'Guardar cambios' : 'Agregar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
